import {
    $get,
    $post
} from '@/utils/http'
//首页
export default {
    //轮播图
    getBannerDEtail(params) {
        return $post('/portal/websit/rotationChartManager/getPicById', params)
    },
    //轮播图详情页
    getBannerDEtail(params) {
        return $post('/portal/websit/rotationChartManager/getPicById', params)
    },
    getcode(params) {
        return $post('/portal/websit/rqcode/listRqCode', params)
    }
}
